import { CanActivateFn } from '@angular/router';
import { localStorageKeys } from '../shared/model/storage.model';

export const viewResultFromSectraGuard: CanActivateFn = (route) => {
  const url = route.url.map(url => url.path).join('/');
  localStorage.setItem(localStorageKeys.VIEW_SECTRA_URL, '/' + url);
  return true;
};
